module.exports = __webpack_public_path__ + "static/media/client28.01c864ef.webp";